// https://vuex.vuejs.org/en/mutations.html

export default {
  SetAuthentication (state, value) {
    state.isAuthenticated = value
  },
  SetUser (state, value) {
    state.user = value
  },
}
